import React from "react";
import { UiComponents } from "@simulanisindia/ui";

const { BackButton, SimInputBar, DropdownSearch } = UiComponents;

const CreateUser = ({ userDetails, setUserDetails, disable=false }) => {
  return (
    <>
      <div className="input-section">
        <h6>User Details</h6>
        <div className="row section-data">
          <div className="col-md-6 mt-3">
            <SimInputBar
              label="Name*"
              placeholder="Enter User Name"
              value={userDetails.name}
              onChange={(e) => setUserDetails((pre) => ({ ...pre, name: e.target.value }))}
            />
          </div>
          <div className="col-md-6 mt-3">
            <SimInputBar
              label="Email* (Either Email or UID is required)"
              disabled={disable}
              placeholder="Enter Email Address"
              value={userDetails.email}
              onChange={(e) => setUserDetails((pre) => ({ ...pre, email: e.target.value.replace(/\s/g, "") }))}
            />
          </div>

          <div className="col-md-6 mt-3">
            <SimInputBar
              label="UID* (Either Email or UID is required)"
              disabled={disable}
              placeholder="Enter UID"
              value={userDetails.uid}
              onChange={(e) => setUserDetails((pre) => ({ ...pre, uid: e.target.value.replace(/\s/g, "") }))}
            />
          </div>

          <div className="col-md-6 mt-3">
            <SimInputBar
              label="Phone"
              placeholder="Enter Phone"
              value={userDetails.phone}
              onChange={(e) => setUserDetails((pre) => ({ ...pre, phone: e.target.value }))}
            />
          </div>

          <div className="col-md-6 mt-3">
            <SimInputBar
              label="Designation"
              placeholder="Enter Designation"
              value={userDetails.designation}
              onChange={(e) => setUserDetails((pre) => ({ ...pre, designation: e.target.value }))}
            />
          </div>

          {userDetails.uid.length > 0 && (
            <div className="col-md-6 mt-3">
              <SimInputBar
                label="Password*"
                disabled={disable}
                placeholder="Enter Password"
                value={disable ? "********" : userDetails.password}
                onChange={(e) => setUserDetails((pre) => ({ ...pre, password: e.target.value }))}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CreateUser;
